import { rem } from "polished";
import styled from "styled-components";

import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";

import {
  CARD_BORDER_WIDTH,
  CARD_HORIZONTAL_GAP,
  CARD_VERTICAL_GAP,
} from "../constants";

export const Wrapper = withViewportStyle("div")`
  display: inline-block;
  border: ${rem(CARD_BORDER_WIDTH)} solid #000;
  border-radius: ${rem(20)};
  background-color: white;
  margin: 0 ${rem(CARD_HORIZONTAL_GAP)} ${rem(CARD_VERTICAL_GAP)};
  width: ${rem(388 + 2 * CARD_BORDER_WIDTH)};
  overflow: hidden;

  ${(props) =>
    props.$viewport.mobile`
      width: ${rem(338 + 2 * CARD_BORDER_WIDTH)};
    `}

  .booth-banner-image {
    border-top-left-radius: ${rem(20 - CARD_BORDER_WIDTH)};
    border-top-right-radius: ${rem(20 - CARD_BORDER_WIDTH)};
  }
`;

export const ContentWrapper = styled.div`
  padding: ${rem(24)};
  position: relative;
  background: #fff;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: ${rem(8)};
`;

export const Logo = styled.img`
  height: ${rem(32)};
  width: ${rem(32)};
  object-fit: cover;
  border-radius: 50%;
  margin-right: ${rem(8)};
`;

export const Heading = styled.h4`
  font-family: ${({ theme }) =>
    theme.fontImports[0]?.font?.name ?? theme.fonts[0].value};
  color: #000;
  font-weight: 600;
  font-size: ${rem(20)};
  line-height: ${rem(32)};
`;

export const Description = styled.p`
  font-family: ${({ theme }) =>
    theme.fontImports[0]?.font?.name ?? theme.fonts[0].value};
  color: #4a4a4a;
  font-weight: 400;
  font-size: ${rem(14)};
  line-height: ${rem(26)};
`;
